import React from 'react';
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ReferenceArea
} from 'recharts';

import { TICK_STYLE, TOOLTIP_WRAPPER_STYLE } from './constants';
import { ApiKeyTooltip } from './tooltips';
import type { ApiKeyDataPoint, ChartReferenceArea } from './types';

interface ApiKeyTrendChartProps {
  data: ApiKeyDataPoint[];
  showOverlays: boolean;
  referenceAreas: ChartReferenceArea[];
  formatTimestamp: (value: number | string) => string;
}

export const ApiKeyTrendChart: React.FC<ApiKeyTrendChartProps> = ({
  data,
  showOverlays,
  referenceAreas,
  formatTimestamp
}) => (
  <div className="p-2 sm:p-3" style={{ minHeight: '240px' }}>
    <ResponsiveContainer width="100%" height={220}>
      <BarChart data={data}>
        <CartesianGrid strokeDasharray="3 3" stroke="#374151" />
        {showOverlays && referenceAreas.map((area) => (
          <ReferenceArea
            key={`${area.type}-${area.start}`}
            x1={area.start}
            x2={area.end}
            fill={area.type === 'holiday' ? '#fbbf24' : '#9ca3af'}
            fillOpacity={0.2}
            stroke="none"
          />
        ))}
        <XAxis
          dataKey="timestamp"
          tick={TICK_STYLE}
          tickFormatter={formatTimestamp}
          stroke="#6b7280"
          interval="preserveEnd"
        />
        <YAxis
          tick={TICK_STYLE}
          stroke="#6b7280"
        />
        <Tooltip
          content={<ApiKeyTooltip />}
          wrapperStyle={TOOLTIP_WRAPPER_STYLE}
        />
        <Legend />
        <Bar
          dataKey="uniqueApiKeys"
          fill="#ef4444"
          name="Unique API Keys"
          radius={[2, 2, 0, 0]}
        />
      </BarChart>
    </ResponsiveContainer>
  </div>
);
